import type { FC } from 'react';
import styles from './styles.module.scss';

export const Loader: FC<{ className?: string }> = ({ className }) => (
    <div className={`${styles.loader} ${className ?? ''}`}></div>
);
